import controller from './kform-builder.controller';
import template from './kform-builder.html';
// import './kform-content.scss';

export default {
	controller,
	// controllerAs: '$ctrl',
	template,
	bindings:     {
		form: '<?',
		node: '<?',
		options: '<',
	},
};
